<template>
  <div class="direction-wrap">
    <div class="list">
      <div class="group">
        <div class="title">优惠券有什么用？</div>
        <div class="content">
          可用于购买熊猫签证时进行金额减免，但不可提现，不可找零。
        </div>
      </div>

      <div class="group">
        <div class="title">优惠券怎么用？</div>
        <div class="content">
          在熊猫签证购买服务或商品后，在线支付时满足优惠券的使用条件，系统提示有可用优惠券，请选择一张用于减免相应的订单金额，支付剩余金额即可。优惠券不可叠加使用。如果您不想使用优惠券，也可以不选择使用优惠券。
        </div>
      </div>

      <div class="group">
        <div class="title">如何获得优惠券？</div>
        <div class="content">
          熊猫签证会不定期推出优惠活动，获得的优惠券会存放在“我的-优惠券”中。惊喜常常在，欢迎多关注！或者您所在的企业达到一定要求，也可与我们联系成为企业VIP客户，获得专享优惠！（熊猫签证客服：0755-86962269）
        </div>
      </div>

      <div class="group">
        <div class="title">
          如何支付的时候使用了优惠券，后来退款了，优惠券还会退还吗？
        </div>
        <div class="content">
          非常抱歉，优惠券一经使用即失效（企业专享优惠券除外）。如果交易取消或被拒签，您所支付的费用中优惠券部分将不会返还，但其他方式支付的费用会返回到您的账户。
        </div>
      </div>
    </div>

    <div class="footer">
      熊猫签证保留对该活动的最终解释权<br /><br />
      <div class="footer-2">Copyright© 熊猫签证 2016-2017, 版权所有</div>
    </div>
  </div>
</template>

<script>
import utils from '../services/tools.js';

export default {
  name: 'couponUsage',
  created() {
    utils.setTitle('优惠券使用说明');
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  line-height: 1;
}

html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
  background-color: white;
}

body {
  font-family: Segoe UI, Lucida Grande, Helvetica, Arial, Microsoft YaHei,
    FreeSans, Arimo, Droid Sans, wenquanyi micro hei, Hiragino Sans GB,
    Hiragino Sans GB W3, FontAwesome, sans-serif;
}

.direction-wrap {
  height: 100%;
  padding: 18px 0 0 0;
  background-color: white;
}

.list {
  padding: 0 11px;
  font-size: 16px;
  min-height: 100%;
  margin-bottom: -90px;
}

.list::after {
  content: '';
  display: block;
  height: 90px;
}

.list .group {
  margin-top: 30px;
}

.list .group:first-of-type {
  margin-top: 0;
}

.list .title {
  padding-left: 11px;
  color: #333;
  position: relative;
  line-height: 22px;
}

.list .title::before {
  background-color: #ff6f75;
  height: 15px;
  width: 3px;
  content: '';
  display: block;
  position: absolute;
  top: 4px;
  left: 0;
  border-radius: 2px;
}

.list .content {
  color: #909090;
  padding-left: 11px;
  line-height: 1.6;
  margin-top: 8px;
}

.list .link {
  color: #ff5a60;
  margin-left: 11px;
  margin-top: 8px;
  display: inline-block;
  text-decoration: none;
}

.list .gt {
  font-size: 14px;
}

.list .gt:first-of-type {
  margin-left: 2px;
}

.list .gt + .gt {
  position: relative;
  left: -7px;
  font-weight: bold;
}

.footer {
  color: #ff5a60;
  font-size: 14px;
  height: 40px;
  text-align: center;
  margin-top: 40px;
}

.footer-2 {
  color: #777;
  font-size: 12px;
}
</style>
